export default "__VITE_ASSET__zVu_yy3X__"